import $ from 'jquery';
import '../Language/parsley';


/**
 * @param password {string}
 * @returns {Number}
 */
function getEntropyStrength(password) {
    return zxcvbn(password).score;
}

/**
 * @param $elem {jQuery}
 * @param strength {Number|string}
 */
function renderStrengthIndicator($elem, strength) {
    $elem.attr('data-strength', `${strength}`);
}

$('.entropy-check').each((i, elem) => {
    const $elem = $(elem);
    let $for;
    try {
        $for = $($elem.attr('data-for'));
    } catch (e) {
        console.error(e);
        $elem.remove();
        return;
    }

    if ($for.length === 0) {
        console.error('Element not found');
        $elem.remove();
        return;
    }

    renderStrengthIndicator($elem, 'none');
    $for.attr('data-strength', 'none');
    $for.on('input', () => {
        let v = $for.val();
        if (v === '') {
            $for.attr('data-strength', 'none');
            renderStrengthIndicator($elem, 'none');
            return;
        }

        let score = getEntropyStrength(v);
        $for.attr('data-strength', score);
        renderStrengthIndicator($elem, score);
    });

    window.zxcvbnReady = window.zxcvbnReady || [];
    window.zxcvbnReady.push(() => {
        $for.trigger('input');
    });
});
